<template>
  <div class="hotspot-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <div class="list">
          <div class="item">
            <img
              :src="staticImg ? staticImg + 'index-tj-01.png' : ''"
              alt=""
              class="pic"
            />
          </div>
          <div class="item">
            <div class="banner-box">
              <el-carousel
                trigger="click"
                height="129px"
                style="width: 265px;"
                :autoplay="false"
                @change="handleChangeBanner($event)"
              >
                <el-carousel-item v-for="(item, index) in info.banner" :key="index">
                  <img
                    :src="item.pic"
                    alt=""
                    class="pic"
                    style="width: 265px;border-radius: 5px"
                  />
                </el-carousel-item>
              </el-carousel>
            </div>
            <div class="jt">
              <i class="el-icon-right"></i>
            </div>
            <div class="info-box">
              <div class="info">
                <div class="left">
                  轮播图区域
                </div>
                <div class="right" v-if="info.banner[bannerIndex]">
                  <div>
                    <p>平均停留时长：</p>
                    <span>{{ timeFormat(info.banner[bannerIndex].hotInfo.durationTime) }}</span>
                  </div>
                  <div>
                    <p>总点击次数：</p>
                    <span>{{ info.banner[bannerIndex].hotInfo.clicksNumber }}</span>
                  </div>
                  <div>
                    <p>点击人数：</p>
                    <span>{{ info.banner[bannerIndex].hotInfo.clicksPeople }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="item">
            <img
              :src="staticImg ? staticImg + 'index-tj-02.png' : ''"
              alt=""
              class="pic"
            />
            <div class="jt">
              <i class="el-icon-right"></i>
            </div>
            <div class="info-box">
              <div class="info">
                <div class="left">
                  分类区域
                </div>
                <div class="right">
                  <div>
                    <p>平均停留时长：</p>
                    <span>{{ timeFormat(info.classify.durationTime) }}</span>
                  </div>
                  <div>
                    <p>总点击次数：</p>
                    <span>{{ info.classify.clicksNumber }}</span>
                  </div>
                  <div>
                    <p>点击人数：</p>
                    <span>{{ info.classify.clicksPeople }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="item">
            <img
              :src="staticImg ? staticImg + 'index-tj-03.png' : ''"
              alt=""
              class="pic"
            />
            <div class="jt">
              <i class="el-icon-right"></i>
            </div>
            <div class="info-box">
              <div class="info">
                <div class="left">
                  热门品牌
                </div>
                <div class="right">
                  <div>
                    <p>平均停留时长：</p>
                    <span>{{ timeFormat(info.brand.durationTime) }}</span>
                  </div>
                  <div>
                    <p>总点击次数：</p>
                    <span>{{ info.brand.clicksNumber }}</span>
                  </div>
                  <div>
                    <p>点击人数：</p>
                    <span>{{ info.brand.clicksPeople }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="item">
            <img
              :src="staticImg ? staticImg + 'index-tj-04.png' : ''"
              alt=""
              class="pic"
            />
            <div class="jt">
              <i class="el-icon-right"></i>
            </div>
            <div class="info-box">
              <div class="info">
                <div class="left">
                  热门产品
                </div>
                <div class="right">
                  <div>
                    <p>平均停留时长：</p>
                    <span>{{ timeFormat(info.product.durationTime) }}</span>
                  </div>
                  <div>
                    <p>总点击次数：</p>
                    <span>{{ info.product.clicksNumber }}</span>
                  </div>
                  <div>
                    <p>点击人数：</p>
                    <span>{{ info.product.clicksPeople }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="item">
            <img
              :src="staticImg ? staticImg + 'index-tj-05.png' : ''"
              alt=""
              class="pic"
            />
            <div class="jt">
              <i class="el-icon-right"></i>
            </div>
            <div class="info-box">
              <div class="info">
                <div class="left">
                  最新文章
                </div>
                <div class="right">
                  <div>
                    <p>平均停留时长：</p>
                    <span>{{ timeFormat(info.article.durationTime) }}</span>
                  </div>
                  <div>
                    <p>总点击次数：</p>
                    <span>{{ info.article.clicksNumber }}</span>
                  </div>
                  <div>
                    <p>点击人数：</p>
                    <span>{{ info.article.clicksPeople }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="item">
            <img
              :src="staticImg ? staticImg + 'index-tj-06.png' : ''"
              alt=""
              class="pic"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import Header from '../../components/common/header';
import { staticImg } from '@/config'; // oss 图片地址

  export default {
    components: {
      Header
    },
    name: 'banner',
    data() {
      return {
        loading: 0, // 加载中
        currentPage: 1, // 当前页码
        size: 20, // 每页条数
        total: 0, // 总页数
        title: {
          // 页面标题
          firstTitile: '商城设置',
          secondTitle: ' '
        },
        staticImg: staticImg,
        info: {
          classify: {},
          brand: {},
          product: {},
          article: {},
          banner: []
        },
        bannerIndex: 0
      };
    },
    mounted() {
      // 获取列表
      this.getHotspotList();
    },
    computed: {},
    methods: {
      // 获取轮播列表
      getHotspotList() {
        this.loading++;
        this.httpGet(this.$root.getHotspotList, {}).then(
          (res) => {
            this.loading--;
            this.info = res;
            // this.total = res.total;
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      },
      timeFormat(time) {
        let str = '';
        if(time < 60) {
          return (time + '秒')
        } else if(time < 3600) {
          if(Math.floor(time / 60)) str += (Math.floor(time / 60) + '分');
          if(time % 60) str += (time % 60 + '秒');
          return str;
        } else {
          if(Math.floor(time / 3600)) str += (Math.floor(time / 3600) + '小时');
          if(Math.floor(time / 60)) str += (Math.floor(time / 60) + '分');
          if(time % 60) str += (time % 60 + '秒');
          return str;
        };

      },
      handleChangeBanner(e){
        this.bannerIndex = e;
      }
    }
  };
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.hotspot-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    padding: 0 20px 20px;

    // content 表格
    .content {
      flex: 1;
      width: 100%;
      font-size: 14px;
      // background: white;
      box-sizing: border-box;
      // padding: 24px 32px;
      border-radius: 2px;
      flex-x(flex-start, flex-start);
      .list{
          flex-y(flex-start, flex-start);
          .banner-box{
            width: 275px;
            background: #F6F8FB;
            flex-x(center);
          }
          .item{
              flex-x(flex-start, center);
              align-items: stretch;
              .pic{
                  width: 275px;
              }
              .jt{
                  width: 60px;
                  flex-x(center);
                  word(24px, #FF5733);
              }
              .info-box{
                flex-x(flex-start, center);
              }
              .info{
                  flex-x(flex-start, center);
                  // align-items: stretch;
                  height: 80%;
                  background: #fff;
                  .left{
                      width: 100px;
                      word(16px, #333);
                      flex-x(center);
                      font-weight: bold;
                      height: 48px;
                      border-right: 1px solid #E6E6E6;
                  }
                  .right{
                      width: 200px;
                      flex-y(flex-start, flex-start);
                      padding-left: 20px;
                      box-sizing: border-box;

                      div{
                          flex-x(flex-start, center);
                          word(14px, #333);
                          p{
                              width: 100px;
                              word(14px, #666);
                              text-align: right;
                          }
                      }
                  }
              }
          }
      }
    }
  }
}
</style>
